(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    const bars = document.querySelectorAll('.announcement-bar[data-rotation]');
    bars.forEach((bar) => {
      const slides = bar.querySelectorAll('.announcement-bar__slide');
      if (slides.length < 2) return;
      const interval = parseInt(bar.getAttribute('data-rotation'), 10) || 5000;
      let active = 0;
      setInterval(() => {
        slides[active].setAttribute('data-active', 'false');
        slides[active].setAttribute('aria-hidden', 'true');
        active = (active + 1) % slides.length;
        slides[active].setAttribute('data-active', 'true');
        slides[active].setAttribute('aria-hidden', 'false');
      }, interval);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__bfoureCartDrawerInit) return;
    window.__bfoureCartDrawerInit = true;

    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    function openDrawer() {
      if (typeof drawer.showModal === 'function') drawer.showModal();
      else drawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (typeof drawer.close === 'function') drawer.close();
      else drawer.removeAttribute('open');
      document.body.style.overflow = '';
    }

    document.addEventListener('bfoure:cart:open', openDrawer);

    drawer.addEventListener('click', function (e) {
      if (e.target.matches('[data-cart-drawer-close]') || e.target.closest('[data-cart-drawer-close]')) {
        closeDrawer();
        return;
      }
      var inner = drawer.querySelector('.cart-drawer__inner');
      if (!inner) return;
      var rect = inner.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
        closeDrawer();
      }
    });

    drawer.addEventListener('cancel', function () {
      document.body.style.overflow = '';
    });

    function refreshDrawer() {
      fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#cart-drawer');
          if (!fresh) return;
          var staleInner = drawer.querySelector('.cart-drawer__inner');
          var freshInner = fresh.querySelector('.cart-drawer__inner');
          if (staleInner && freshInner) {
            staleInner.replaceChildren.apply(staleInner, Array.prototype.slice.call(freshInner.children));
          }
        });
    }
    document.addEventListener('bfoure:cart:changed', refreshDrawer);

    drawer.addEventListener('click', function (e) {
      var keyEl = e.target.closest('[data-line-key]');
      if (!keyEl) return;
      var lineKey = keyEl.dataset.lineKey;
      if (!lineKey) return;

      if (e.target.closest('[data-cart-quantity-increment]')) {
        updateLine(lineKey, function (qty) { return qty + 1; });
      } else if (e.target.closest('[data-cart-quantity-decrement]')) {
        updateLine(lineKey, function (qty) { return Math.max(0, qty - 1); });
      } else if (e.target.closest('[data-cart-remove]')) {
        updateLine(lineKey, function () { return 0; });
      }
    });

    function updateLine(lineKey, qtyFn) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = (cart.items || []).find(function (i) { return i.key === lineKey; });
          if (!line) return;
          var newQty = qtyFn(line.quantity);
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: newQty })
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('bfoure:cart:changed'));
        });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-menu"]) return;
  try {
    
  (function () {
    if (window.__bfoureMobileMenuInit) return;
    window.__bfoureMobileMenuInit = true;

    var menu = document.getElementById('mobile-menu');
    if (!menu) return;

    function openMenu() {
      if (typeof menu.showModal === 'function') menu.showModal();
      else menu.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      if (typeof menu.close === 'function') menu.close();
      else menu.removeAttribute('open');
      document.body.style.overflow = '';
    }

    document.addEventListener('bfoure:menu:open', openMenu);

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mobile-menu-toggle]')) {
        openMenu();
      }
    });

    menu.addEventListener('click', function (e) {
      if (e.target.closest('[data-mobile-menu-close]')) {
        closeMenu();
        return;
      }
      var inner = menu.querySelector('.mobile-menu__inner');
      if (!inner) return;
      var rect = inner.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
        closeMenu();
      }
    });

    menu.addEventListener('cancel', function () {
      document.body.style.overflow = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.product__gallery--gallery:not([data-init])').forEach(function (gallery) {
      gallery.setAttribute('data-init', 'true');
      var thumbnails = gallery.parentElement.querySelectorAll('[data-thumbnail-index]');
      thumbnails.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-thumbnail-index');
          gallery.querySelectorAll('.product__media-item').forEach(function (item) {
            item.classList.toggle('product__media-item--active', item.getAttribute('data-media-index') === idx);
          });
          thumbnails.forEach(function (t) {
            t.classList.toggle('product__thumbnail--active', t.getAttribute('data-thumbnail-index') === idx);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
